export default "__VITE_ASSET__3a8918fe__"